import { Divider } from "@mui/material";
import { isESimStatusActivated } from "@utils/esim";
import { ESimDetails } from "@features/ManageSim/ESimDetails";
import { ESimActivation } from "@features/ManageSim/ESimActivation";
import { IESim } from "@pages/AccountDetails/interface/IAccountDetailsPage";

interface IParams {
    eSimDetails: IESim;
    serviceId: string;
    serviceName: string;
}

export const ESimOfferDetails = (props: IParams) => {
    const { eSimDetails, serviceId, serviceName } = props;

    return (
        <>
            <Divider />
            {isESimStatusActivated(eSimDetails) ? (
                <ESimDetails eSimDetails={eSimDetails} />
            ) : (
                <ESimActivation
                    serviceWithESimToActivateList={[
                        {
                            ...eSimDetails,
                            serviceId,
                            phoneNumber: serviceName,
                        },
                    ]}
                />
            )}
        </>
    );
};
